var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M415.998 480C415.936 480 415.858 480 415.795 480C412.326 479.906 409.311 477.594 408.326 474.281L288 68.157L167.674 474.281C166.689 477.594 163.674 479.906 160.205 480C156.721 479.719 153.596 477.938 152.455 474.656L0.457 42.657C-1.012 38.501 1.176 33.907 5.348 32.47C9.519 30.97 14.098 33.188 15.551 37.345L159.346 446.031L280.328 37.72C282.359 30.97 293.641 30.97 295.672 37.72L416.654 446.031L560.449 37.345C561.918 33.188 566.512 30.97 570.652 32.47C574.824 33.907 577.012 38.501 575.543 42.657L423.545 474.656C422.42 477.875 419.389 480 415.998 480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW);
export default __webpack_public_path__ + "static/media/w.c612119ec2dffdc55b7b9bd09fbd6581.svg";
export { ForwardRef as ReactComponent };